import { getError, getLanguageObj, getResponse, isUndNullEmpNew, setDateTimeFormatGlobal, setSeparatorsNumbersNew, settings } from '../UtilsHelper'
import $ from 'jquery';
import { Chart } from 'chart.js';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { icons, labels, react } = settings;
const { tempusDominus, } = react;

const currentMethod = 'rateshelper - functions';

export const setRatesVariations = ({
    data = [],
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
    subMethod = '',
}) => {
    const currentMethod = 'setRatesVariations';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        let itemFirst = 0.00;
        let itemSecond = 0.00;
        let itemClass = '';
        let percent = 0.00;
        let dateTime12Local = '';
        let dateTime24Local = '';
        const dateTimeFormat = {
            date: languageObj?.format?.date?.f1,
            time: languageObj?.format?.time?.type,
        };
        response.result = [];
        //#endregion variables

        //#region process
        if (data?.length > 1) {
            //#region order by
            data = data?.map((detail) => {
                return {
                    ...detail,
                    orderByDate: setDateTimeFormatGlobal({
                        date: detail?.register,
                        type: tempusDominus?.formatDateymdTwo,
                        format: 24,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result,
                }
            });
            data?.sort((a, b) => a.orderByDate > b.orderByDate ? 1 : -1);
            //#endregion order by

            //#region process
            for (let index = 0; index < data?.length; index++) {
                const detail = data[index];

                if (index === 0) {
                    itemFirst = detail?.rate;
                    itemSecond = detail?.rate;
                } else {
                    itemFirst = itemSecond;
                    itemSecond = detail?.rate;
                }
                percent = 0.00;
                percent = (itemSecond - itemFirst).toFixed(settings?.numberPositions?.decimalsPlace);
                percent = (((percent / (itemSecond === 0.00 ? 1.00 : itemSecond))) * 100.00).toFixed(settings?.numberPositions?.decimalsPlace);
                dateTime12Local = setDateTimeFormatGlobal({
                    date: detail?.register,
                    type: dateTimeFormat?.date,
                    format: dateTimeFormat?.time,
                    addTime: false,
                    withSeconds: false,
                    subMethod: currentMethod
                })?.result;
                dateTime24Local = detail?.orderByDate;

                if (parseFloat(percent) > 0.00) {
                    itemClass = `<i class='${icons?.farFa?.arrowAltCircleUp} text-success' title='${setSeparatorsNumbersNew({ number: percent, withDecimals: true, subMethod: currentMethod })?.result}%' style='cursor: pointer;'></i>`;
                } else if (parseFloat(percent) === 0.00) {
                    itemClass = `<i class='${icons?.farFa?.pauseCircle} text-info' title='${setSeparatorsNumbersNew({ number: percent, withDecimals: true, subMethod: currentMethod })?.result}%' style='cursor: pointer;'></i>`;
                } else {
                    itemClass = `<i class='${icons?.farFa?.arrowAltCircleDown} text-danger' title='${setSeparatorsNumbersNew({ number: percent, withDecimals: true, subMethod: currentMethod })?.result}%' style='cursor: pointer;'></i>`;
                }

                response.result.push([
                    `${itemClass} ${setSeparatorsNumbersNew({ number: detail?.rate, withDecimals: true, subMethod: currentMethod })?.result}`,
                    dateTime12Local,
                    dateTime24Local,
                    detail?.id,
                    `${setSeparatorsNumbersNew({ number: detail?.rate, withDecimals: true, subMethod: currentMethod })?.result}`,
                ]);
            };
            //#endregion process
        } else {
            dateTime12Local = setDateTimeFormatGlobal({
                date: data?.[0]?.register,
                type: dateTimeFormat?.date,
                format: dateTimeFormat?.time,
                addTime: false,
                withSeconds: false,
                subMethod: currentMethod
            })?.result;
            dateTime24Local = setDateTimeFormatGlobal({
                date: data?.[0]?.register,
                type: dateTimeFormat?.type,
                format: dateTimeFormat?.date,
                addTime: false,
                withSeconds: false,
                subMethod: currentMethod
            })?.result;
            response.result.push([
                `<i class='${icons?.farFa?.pauseCircle} text-info' title='0.00%'></i> ${setSeparatorsNumbersNew({ number: data?.[0]?.rate, withDecimals: true, subMethod: currentMethod })?.result}`,
                dateTime12Local,
                dateTime24Local,
                data?.[0]?.id,
                `${setSeparatorsNumbersNew({ number: data?.[0]?.rate, withDecimals: true, subMethod: currentMethod })?.result}`,
            ]);
        }
        //#endregion process
    } catch (ex) {
        return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}

export const setRateVariationsGraph = ({
    grpahId = '',
    data = [],
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
    subMethod = '',
}) => {
    const currentMethod = 'setRateVariationsGraph';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        let areaChartObj = {};
        let areaChartCanvas = null;
        let areaChartOptions = null;
        let areaChartData = null;
        const dateTimeFormat = {
            date: languageObj?.format?.date?.f1,
            // time: languageObj?.format?.time?.type,
            time: 0,
        };
        //#endregion variables

        //#region process
        areaChartObj = $(`#${grpahId}`);
        if (!isUndNullEmpNew({ data: areaChartObj, subMethod: currentMethod, })?.result &&
            !isUndNullEmpNew({ data: areaChartObj?.get(0), subMethod: currentMethod, })?.result) {
            areaChartCanvas = areaChartObj?.get(0)?.getContext('2d');
            //#region old code
            // const zeroFormat = setSeparatorsNumbersNew({ number: 0, withDecimals: true, subMethod: currentMethod })?.result;
            //#endregion old code

            areaChartData = {
                labels: [
                    data?.length > 0 ? setDateTimeFormatGlobal({
                        date: data?.[0]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                    data?.length > 0 && data?.length > 1 ? setDateTimeFormatGlobal({
                        date: data?.[1]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                    data?.length > 0 && data?.length > 2 ? setDateTimeFormatGlobal({
                        date: data?.[2]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                    data?.length > 0 && data?.length > 4 ? setDateTimeFormatGlobal({
                        date: data?.[3]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                    data?.length > 0 && data?.length > 4 ? setDateTimeFormatGlobal({
                        date: data?.[4]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                    data?.length > 0 && data?.length > 5 ? setDateTimeFormatGlobal({
                        date: data?.[5]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                    data?.length > 0 && data?.length > 6 ? setDateTimeFormatGlobal({
                        date: data?.[6]?.register,
                        type: dateTimeFormat?.date,
                        format: dateTimeFormat?.time,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod
                    })?.result : '',
                ],
                datasets: [
                    {
                        label: labels?.rate?.[languageObj?.id],
                        /*backgroundColor: 'rgba(60,141,188,0.9)',*/
                        /*backgroundColor: '#8dc4e3',*/
                        backgroundColor: '#a8cde3',
                        /*borderColor: 'rgba(60,141,188,0.8)',*/
                        borderColor: '#72bde8',
                        pointStyle: 'circle',
                        pointRadius: true,
                        /*pointColor: '#3b8bba',*/
                        pointColor: '#021724',
                        pointHoverRadius: 5,
                        pointHoverBorderWidth: 10,
                        pointBorderWidth: 5,
                        /*pointStrokeColor: 'rgba(60,141,188,1)',*/
                        /*pointStrokeColor: '#0E212D',*/
                        pointStrokeColor: '#0E212A',
                        /*pointHighlightFill: '#fff',*/
                        pointHighlightFill: '#0c3b54',
                        /*pointHighlightStroke: 'rgba(60,141,188,1)',*/
                        pointHighlightStroke: '#3c8dbc',

                        data: [
                            data?.length > 0 ? data?.[0]?.rate : 0,
                            data?.length > 0 && data?.length > 1 ? data[1].rate : 0,
                            data?.length > 0 && data?.length > 2 ? data[2].rate : 0,
                            data?.length > 0 && data?.length > 4 ? data[3].rate : 0,
                            data?.length > 0 && data?.length > 4 ? data[4].rate : 0,
                            data?.length > 0 && data?.length > 5 ? data[5].rate : 0,
                            data?.length > 0 && data?.length > 6 ? data[6].rate : 0,
                        ],
                        //#region old code
                        // data: [
                        //     data?.length > 0 ? setSeparatorsNumbersNew({ number: data?.[0]?.rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        //     data?.length > 0 && data?.length > 1 ? setSeparatorsNumbersNew({ number: data[1].rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        //     data?.length > 0 && data?.length > 2 ? setSeparatorsNumbersNew({ number: data[2].rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        //     data?.length > 0 && data?.length > 4 ? setSeparatorsNumbersNew({ number: data[3].rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        //     data?.length > 0 && data?.length > 4 ? setSeparatorsNumbersNew({ number: data[4].rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        //     data?.length > 0 && data?.length > 5 ? setSeparatorsNumbersNew({ number: data[5].rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        //     data?.length > 0 && data?.length > 6 ? setSeparatorsNumbersNew({ number: data[6].rate, withDecimals: true, subMethod: currentMethod })?.result : zeroFormat,
                        // ],
                        //#endregion old code
                    },
                ]
            }

            areaChartOptions = {
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        gridLines: {
                            display: true,
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: true,
                        }
                    }]
                }
            }

            //#region old code
            // areaChartData?.datasets[0]?.data?.forEach(function (element, index, array) {
            //     array[index] = element.replaceAll(',', '');
            // });
            //#endregion old code

            /* This will get the first returned node in the jQuery collection. */
            response.result = new Chart(areaChartCanvas, {
                type: 'line',
                data: areaChartData,
                options: areaChartOptions
            });

            //console.log(areaChart);
            //console.clear();
        }

        //#endregion process
    } catch (ex) {
        return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
    }
    return response;
}